import angular from 'angular';
import { MeurhVagasService } from './vagas.service';

export const MeurhVagasListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider) {
        const resolve = {
            'entity': [
                'MeurhVagasService',
                '$stateParams',
                '$state',
                '$rootScope',
                '$q',
                function (
                    entityService: MeurhVagasService,
                    $stateParams: angular.ui.IStateParamsService,
                    $state: angular.ui.IStateService,
                    $rootScope: angular.IRootScopeService & { session: any },
                    $q: angular.IQService
                ) {
                    if (!$stateParams['vaga']) {
                        return $q<void>(() => $state.go('meurh_vagas'));
                    }

                    return entityService.get($stateParams['vaga'])
                        .then((data) => {
                            const deveRedirecionar = data.estabelecimento !== $rootScope.session.entities.estabelecimento.estabelecimento;
                            if (deveRedirecionar) {
                                return $q(() => $state.go('meurh_vagas'));
                            }

                            return data;
                        })
                        .catch((error) => {
                            if (error.status === 404) {
                                return $q(() => {
                                    if ($state.href('meurh_vagas_not_found', $stateParams)) {
                                        $state.go('meurh_vagas_not_found', $stateParams);
                                    } else {
                                        $state.go('not_found', $stateParams);
                                    }
                                });
                            }

                            return $q.reject(error);
                        });
                }
            ]
        };

        $stateProvider
            .state('meurh_vagas', {
                url: '/vagas?q?estabelecimento',
                template: require('html-loader!./index/vagas.index.html'),
                controller: 'Meurh\VagasIndexController',
                controllerAs: 'mrh_vgs_lst_cntrllr',
                reloadOnSearch: false
            })
            .state('meurh_vagas_new', {
                parent: 'meurh_vagas',
                url: '/new',
                template: require('html-loader!./new/vagas.new.html'),
                controller: 'MeurhVagasNewController',
                controllerAs: 'mrh_vgs_frm_nw_cntrllr'
            })
            .state('meurh_vagas_show', {
                parent: 'meurh_vagas',
                url: '/show/:vaga',
                resolve,
                template: require('html-loader!./show/vagas.show.html'),
                controller: 'MeurhVagasShowController',
                controllerAs: 'mrh_vgs_frm_shw_cntrllr'
            })
            .state('meurh_vagas_edit', {
                parent: 'meurh_vagas',
                url: '/edit/:vaga',
                resolve,
                template: require('html-loader!./edit/vagas.edit.html'),
                controller: 'Meurh\VagasEditController',
                controllerAs: 'mrh_vgs_frm_edit_cntrllr'
            });
    }
];
